export default '/safra/seriehistorica'
